import { useLanguage } from '@/context/LanguageContext'

function About() {
  const { t } = useLanguage()

  return (
    <section className="bg-[#3d2b1f] py-10">
      <div className="max-w-md mx-auto px-4 text-center">
        <h2 className="text-xl font-bold text-amber-50 mb-3 animate-fade-in-up">
          {t.about.title}
        </h2>
        <p className="text-amber-100/75 text-sm leading-relaxed animate-fade-in-up">
          {t.about.text}
        </p>
      </div>
    </section>
  )
}

export default About
